import instanceService from './instance'
import { USER_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(USER_SERVER_URL)

export const userService = {
  createUser,
  getUsers,
  editRoles,
  generatePassword,
  getUser,
  updateUser,
  getCurrentUser,
  typeaheadUsers,
  listUsersByIds,
  getConfiguration
}

function getConfiguration() {
  const options = {
    method: 'GET',
    url: '/configuration'
  }
  return instance(options)
}

function createUser(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/'
  }
  return instance(options)
}

function getUsers(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/search'
  }
  return instance(options)
}

function editRoles(id, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${id}/roles`
  }
  return instance(options)
}

function generatePassword(id) {
  const options = {
    method: 'POST',
    url: `/${id}/password`
  }
  return instance(options)
}

function getUser(id) {
  const options = {
    method: 'GET',
    url: `/${id}`
  }
  return instance(options)
}

function updateUser(id, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${id}`
  }
  return instance(options)
}

function getCurrentUser() {
  const options = {
    method: 'GET',
    url: `/current`
  }
  return instance(options)
}

function typeaheadUsers(name, document = false, active) {
  const options = {
    method: 'GET',
    url: `/typeahead?name=${name}&document=${document}&${active ? active : ''}`
  }
  return instance(options)
}

function listUsersByIds(ids) {
  const options = {
    method: 'GET',
    url: '/list?ids=' + ids
  }
  return instance(options)
}
